import {Placemark, Polyline, ObjectManager} from "react-yandex-maps";
import React from "react";
import i18n from "../i18n";

export const mapHelper = {
  placemarkersFactory
};

function drawPlaces(places) {
  let collection = {
    "type": "FeatureCollection",
    "features": null,
  };
  collection.features = places.map((item, index) => {
      return {
        "type": "Feature",
        "id": index,
        "geometry": {
          "type": "Point",
          "coordinates": [item.lat, item.lon]
        },
        "properties": {
          "hintContent": item.address,
          "iconContent": index+1,
          "iconColor": (item.type === "load" ? '#eb5c3b' : '#44813f')
        },
        "options": {
          "iconColor": (item.type === "load" ? '#eb5c3b' : '#44813f')
        }
      };
  });

  return collection;
}

  const polyline = React.createRef(null);
  const pointsList = React.createRef(null);

function placemarkersFactory(drivers) {

  let Line = <Polyline
    key={'route'}
    geometry={[
      [0, 0],
    ]}
    options={{
      balloonCloseButton: false,
      strokeColor: "#f00",
      strokeWidth: 5,
      strokeOpacity: 0.6,
      strokeStyle: 'longdash',
      visible: 1,
    }}
    instanceRef={polyline}
  />;

  let Points = <ObjectManager
    modules={[
      "objectManager.addon.objectsBalloon",
      "objectManager.addon.objectsHint",
    ]}
    key={'points'}
    options={{
    }}
    instanceRef={pointsList}
  />

  if(pointsList.current) {
    pointsList.current.removeAll();
  }

  let driversCollection = {
    "type": "FeatureCollection",
    "features": null,
  };

  driversCollection.features = null;

  driversCollection.features = drivers.map((item, index) => {
    if (item.driver.location) {
      const location = item.driver.location;
      const image = `/img/svg/32.svg`;

      const balloonInfo = `<div>
          <p><span>${i18n.t('constants.mapHelper.date')}: </span><b>${item.delivery.dateLoading}</b></p>
          <p><span>${i18n.t('constants.mapHelper.driver')}: </span><b>${item.driver.name}</b></p>
          <p><span>${i18n.t('constants.mapHelper.phone')}: </span>
            <a class="link" href="tel:+7${item.driver.phone}"><b>${item.driver.phone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/g, '+7 ($1) $2 $3 $4')}
            </b></a>
          </p>
          <p><span>${i18n.t('constants.mapHelper.truck')}: </span><b>${item.driver.truck ? item.driver.truck.number : '-'}</b></p>
          <p><span>${i18n.t('constants.mapHelper.trailer')}: </span><b>${item.driver.trail ? item.driver.trail.number : '-'}</b></p>
        </div>`;

      return {
        "type": "Feature",
        "id": index,
        "geometry": {
          "type": "Point",
          "coordinates": [location.lat, location.lon]
        },
        "properties": {
          "delivery": item.delivery.number,
          "deliveryObj": item.delivery,
          "balloonContentHeader": `<p><span>${i18n.t('constants.mapHelper.number')} </span>${item.delivery.number}</p>`,
          "balloonContent": balloonInfo,
          "balloonContentFooter": `<p style="text-align: right"><sub >${i18n.t('constants.mapHelper.truck', {date:item.driver.location.dateUpdated})}</sub></p>`
        },
        "options": {
          "iconLayout": "default#image",
          "iconImageSize": [50, 50],
          "iconImageHref": image,
          "balloonOffset": [-10, -30],
          "hintContent": `Рейс #${item.delivery.number}`,
          "hideIconOnBalloonOpen": false
        }
      };
    } else {
      return '';
    }
  });

  let DriversManager = <ObjectManager
    modules={[
      "objectManager.addon.objectsBalloon",
      "objectManager.addon.objectsHint",
    ]}
    key={'driverPlaces'}
    options={{
    }}
    features={driversCollection}
    instanceRef={ref => ref && ref.objects.events.add('click', (e) => {
      const objectId = e.get('objectId');
      let item = ref.objects.getById(objectId);
      let coords = item.properties.deliveryObj.locationHistory;
      polyline.current.geometry.setCoordinates(coords);

      if(pointsList.current.removeAll()) {
        pointsList.current.add(drawPlaces(item.properties.deliveryObj.places));
      }
    })}
  />

  return [Line, Points, DriversManager];
}
